module.exports = __webpack_public_path__ + "static/media/ML_IMT_Eng_Horiz_GOLD_MILLER_1C_4C.2e83046e.png";